import { https } from "../http";
import { showError } from "../utils/index";
import { getProfile } from "./profile";

// Marketplace app install/uninstall (OD-1200). Paid apps (Calendar: $50/mo
// unless the org is grandfathered free) are billed server-side through Stripe,
// so installs MUST go through these endpoints — not a raw business-profile
// update. On success the profile is re-fetched so `installedApps` (and any
// billing change) is reflected everywhere.

const installApp = async (appKey) => {
  try {
    const response = await https().post("/apps/install", { app: appKey });
    if (response?.status === 200) {
      await getProfile();
      return response?.data;
    }
    return false;
  } catch (error) {
    showError(error?.response?.data?.message, error?.response?.status);
    return false;
  }
};

// Uninstalling a PAID app does not remove it immediately (OD-1213): the org
// keeps access until the end of the billing period it already paid for. The
// response carries `pendingCancellation: true` + `accessUntil` in that case.
const uninstallApp = async (appKey) => {
  try {
    const response = await https().post("/apps/uninstall", { app: appKey });
    if (response?.status === 200) {
      await getProfile();
      return response?.data;
    }
    return false;
  } catch (error) {
    showError(error?.response?.data?.message, error?.response?.status);
    return false;
  }
};

// Per-app pricing/state for this org: { [appKey]: { monthlyPrice, free,
// installed, pendingRemoval, accessUntil } }. `pendingRemoval` means the app
// was uninstalled this cycle and stays usable until `accessUntil`.
const getAppsPricing = async () => {
  try {
    const response = await https().get("/apps/pricing");
    return response?.status === 200 ? response?.data : null;
  } catch (error) {
    // Non-blocking — the marketplace still renders without pricing state.
    return null;
  }
};

export { installApp, uninstallApp, getAppsPricing };
